import styled from 'styled-components';

import { Color, theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type ShapeProps = {
  color?: Color;
  size?: number;
};

const Circle = styled.div<ShapeProps>(({ size = 14, color = 'elementBlue100' }) => ({
  height: pxToRem(size),
  width: pxToRem(size),
  backgroundColor: theme.color[color],
  borderRadius: '50%',
}));

export const Shapes = { Circle };
